<template>
  <AddPackageForm :is-view="true" :set-flag="setFlag" parent-name="BusinessGoodsSkuPackage" />
</template>
<script>
import AddPackageForm from '../components/addPackageForm.vue';
import { GOODS_COMBO_TYPES } from '@/utils/constants';
export default {
  name: 'BusinessGoodsSkuPackageView',
  components: {
    AddPackageForm,
  },
  data() {
    return {};
  },
  computed: {
    setFlag() {
      return GOODS_COMBO_TYPES.PACKAGE;
    },
  },
};
</script>
